import React, { useEffect, useState, useRef } from 'react';
interface MagnetProps {
  children: React.ReactNode;
  padding?: number;
  disabled?: boolean;
  magnetStrength?: number;
  className?: string;
  innerClassName?: string;
}
/**
 * Magnet (reactbits.dev inspired)
 * When the cursor enters a configurable radius, the wrapped element subtly
 * translates toward the cursor — feels premium on CTAs.
 */
export function Magnet({
  children,
  padding = 100,
  disabled = false,
  magnetStrength = 2,
  className = '',
  innerClassName = ''
}: MagnetProps) {
  const wrapRef = useRef<HTMLDivElement | null>(null);
  const [pos, setPos] = useState({
    x: 0,
    y: 0
  });
  useEffect(() => {
    if (disabled) return;
    const handleMove = (e: MouseEvent) => {
      const el = wrapRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const dx = e.clientX - cx;
      const dy = e.clientY - cy;
      const distance = Math.hypot(dx, dy);
      const maxDist = Math.max(rect.width, rect.height) / 2 + padding;
      if (distance < maxDist) {
        setPos({
          x: dx / magnetStrength,
          y: dy / magnetStrength
        });
      } else {
        setPos({
          x: 0,
          y: 0
        });
      }
    };
    window.addEventListener('mousemove', handleMove);
    return () => window.removeEventListener('mousemove', handleMove);
  }, [padding, magnetStrength, disabled]);
  return <div ref={wrapRef} className={className} data-id="element-48">
      <div className={innerClassName} style={{
      transform: `translate3d(${pos.x}px, ${pos.y}px, 0)`,
      transition: 'transform 0.3s cubic-bezier(0.23, 1, 0.32, 1)'
    }} data-id="element-49">
        {children}
      </div>
    </div>;
}